<template>
  <div :class="'float-w ' + (info ? 'show': '')" v-if="isShow">
    <div class="float--w">
      <div class="float-tt display-600 not-display-pc">
        <span class="zh">书籍详情</span>
        <span class="en">Description</span>
      </div>
      <div class="btn-close" @click="close()">
        <img src="@/assets/images/icon-close-blk.png" alt="close"/>
      </div>
      <div class="full-bb" v-if="info">
        <div class="book-w">
          <div class="book--w">
            <div class="lp">
              <img class="cover" :src="info.cover.m" alt="artist"/>
            </div>
            <div class="rp">
              <p class="title">{{ info.name }}</p>
              <div class="row">
                <p class="hint">
                  <span class="zh">艺术家</span>
                  <span class="en">Artists</span>
                </p>
                <p class="vv">{{ info.artist }}</p>
              </div>
              <div class="row">
                <template v-if="exhibitions.length">
                  <p class="hint">
                    <span class="zh">相关展览</span>
                    <span class="en">Related Exhibitions</span>
                  </p>
                  <p class="vv">
                    <a v-for="(item,index) in exhibitions" :key="index" @click="goExhibtion(item)">{{ item.title }}</a>
                  </p>
                </template>
              </div>
              <div class="row">
                <p class="hint">
                  <span class="zh">关键词</span>
                  <span class="en">Keywords</span>
                </p>
                <p class="vv">{{ info.remark }}</p>
              </div>
              <div class="row">
                <p class="hint">
                  <span class="zh">图书索取号</span>
                  <span class="en">Book No.</span>
                </p>
                <p class="vv">{{ info.requestCode }}</p>
              </div>
              <div class="row">
                <p class="hint">
                  <span class="zh">ISBN</span>
                  <span class="en">ISBN</span>
                </p>
                <p class="vv">{{ info.isbn }}</p>
              </div>
              <p class="intro">
                {{ info.summary }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {getDetail, getExhibition} from "@/api/book";

export default {
  props: {
    id: {
      type: Number,
      default: null,
    }
  },
  data() {
    return {
      isShow: false,
      info: null,
      exhibitions: [],
    }
  },
  created() {
    (new getExhibition()).success(res => {
      this.exhibitions = res;
    }).run({
      id: this.id
    });
    (new getDetail()).success(res => {
      this.info = res;
      this.show();
    }).run({
      id: this.id
    });
  },
  methods: {
    goExhibtion(item) {
      this.close();
      item.goDetail();
    },
    show() {
      this.isShow = true;
      document.body.style.overflow = "hidden";
    },
    close() {
      this.isShow = false;
      document.body.style.overflow = "auto";
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/page/bookDetail.vue